import { Stack, styled } from "@mui/material"

export const SidebarContainer = styled(Stack)(({ theme }) => ({
  gridArea: "sidebar",
  gap: theme.spacing(2),
}))
